import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight, Check } from "lucide-react";

export default function NewsletterSignup({ source = "landing" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", {
        email: email.trim(),
        name: name.trim() || null,
        source,
      });
      setDone(true);
      toast.success("You're on the list. Welcome.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        className="card-bento flex items-center gap-3 text-[#C9A961]"
        data-testid="newsletter-done"
      >
        <Check className="w-5 h-5" />
        <span>
          You're on the list. Watch for the first dispatch from the path.
        </span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="card-bento" data-testid="newsletter-form">
      <div className="flex items-center gap-2 mb-3">
        <Mail className="w-4 h-4 text-[#C9A961]" />
        <div className="overline">Stay on the path</div>
      </div>
      <h3
        className="text-2xl text-[#F7F5F0] mb-2"
        style={{ fontFamily: "Cormorant Garamond, serif" }}
      >
        Get updates from the Initiative.
      </h3>
      <p className="text-sm text-[#8A8782] mb-5">
        Curriculum releases, partnership openings, and the quiet wins of the men &amp; women
        earning their crowns.
      </p>
      <div className="grid sm:grid-cols-[1fr_auto] gap-3">
        <div className="grid sm:grid-cols-2 gap-3">
          <input
            placeholder="Your name (optional)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input-tcpi"
            data-testid="newsletter-name"
          />
          <input
            required
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input-tcpi"
            data-testid="newsletter-email"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="btn-primary disabled:opacity-50 flex items-center justify-center gap-2"
          data-testid="newsletter-submit"
        >
          {loading ? "Adding…" : "Subscribe"} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </form>
  );
}
